import { Flex, FlexProps } from '@chakra-ui/react';
import { routes } from '~/core/router';
import { ExportPdfButton } from '~/screens/MediaPackDetailDefaultScreen/components/ExportPdfButton';
import { ShareButton } from '~/screens/MediaPackDetailDefaultScreen/components/ShareButton';
import { CreatorType } from '~/types';

import { NavBarProps } from './NavBar.model';
import { ActionsDropDown } from './components/ActionsDropDown';
import { MenuItem } from './components/ActionsDropDown/Actions.types';
import { GoBack } from './components/GoBack';

interface Props extends Omit<NavBarProps, 'activeSection'>, FlexProps {
  creator: CreatorType;
  dropDownMenuActions: MenuItem[];
  creatorSlugParam?: string;
}

export const NavBar: React.FC<Props> = ({
  creatorBenchmarks,
  creatorInsights,
  mediaPack,
  pdfImages,
  creator,
  dropDownMenuActions,
  creatorSlugParam,
  ...props
}) => (
  <Flex
    position="sticky"
    height={{
      base: 12,
      md: 14,
    }}
    justifyContent="center"
    width="100%"
    paddingX={{
      base: 8,
      md: 20,
    }}
    top={0}
    zIndex={1}
    backgroundColor="rgba(243, 245, 246, 0.8)"
    backdropFilter="auto"
    backdropBlur="16px"
    {...props}
  >
    <Flex
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      maxWidth="1050px"
    >
      <GoBack
        href={
          creatorSlugParam
            ? // TODO add to routes
              `/t/${creatorSlugParam}/media-packs`
            : routes.mediaPacks
        }
      />

      <Flex alignItems="center">
        <ExportPdfButton
          data={{
            creator,
            creatorBenchmarks,
            creatorInsights,
            mediaPack,
            pdfImages,
          }}
          marginRight={2}
          iconProps={{
            boxSize: 4,
          }}
        />
        <ShareButton
          data-testid="nav-bar-share-button"
          marginRight={2}
          href={
            creatorSlugParam
              ? // TODO add to routes
                `/t/${creatorSlugParam}/media-packs/${mediaPack.id}/share`
              : routes.mediaPackShareView(mediaPack.id)
          }
        />
        <ActionsDropDown dropDownMenuActions={dropDownMenuActions} />
      </Flex>
    </Flex>
  </Flex>
);
